import {
  fetchMonitorAprAttributes,
  fetchPortfolioLatestData,
  fetchPortfolioTrackRecordsRoundFourDigit,
} from "./portfolio-requests";
import {
  fetchAdjustedDailyPortfolioData,
  fetchDailyPortfolioData,
  fetchDailyTotalAssertData,
} from "./daily-portfolio";

export const fetchHomepageData = async () => {
  const results = await Promise.allSettled([
    fetchPortfolioTrackRecordsRoundFourDigit(),
    fetchDailyPortfolioData(),
    fetchAdjustedDailyPortfolioData(),
  ]);

  return {
    trackRecord: results[0].status === "fulfilled" ? results[0].value : null,
    dailyPortfolioData: results[1].status === "fulfilled" ? results[1].value : null,
    adjustedGrowthData: results[2].status === "fulfilled" ? results[2].value : null,
  };
};

export const fetchDashboardSupplementData = async () => {
  const results = await Promise.allSettled([
    fetchPortfolioLatestData(),
    fetchDailyTotalAssertData(),
    fetchMonitorAprAttributes(),
  ]);

  return {
    portfolioLatestData: results[0].status === "fulfilled" ? results[0].value : [],
    dailyAssetsData: results[1].status === "fulfilled" ? results[1].value : null,
    monitorAprData: results[2].status === "fulfilled" ? results[2].value : [],
  };
};

export const fetchDashboardData = async () => {
  const results = await Promise.allSettled([
    fetchPortfolioLatestData(),
    fetchPortfolioTrackRecordsRoundFourDigit(),
    fetchDailyPortfolioData(),
    fetchDailyTotalAssertData(),
    fetchMonitorAprAttributes(),
    fetchAdjustedDailyPortfolioData(),
  ]);

  return {
    portfolioLatestData: results[0].status === "fulfilled" ? results[0].value : [],
    trackRecord: results[1].status === "fulfilled" ? results[1].value : null,
    dailyPortfolioData: results[2].status === "fulfilled" ? results[2].value : null,
    dailyAssetsData: results[3].status === "fulfilled" ? results[3].value : null,
    monitorAprData: results[4].status === "fulfilled" ? results[4].value : [],
    adjustedGrowthData: results[5].status === "fulfilled" ? results[5].value : null,
  };
};

/** Stage 1: Portfolio allocation + track summary (totalValue, for OverviewStats) */
export const fetchDashboardStage1 = async () => {
  const results = await Promise.allSettled([
    fetchPortfolioLatestData(),
    fetchPortfolioTrackRecordsRoundFourDigit(),
  ]);
  return {
    portfolioLatestData: results[0].status === "fulfilled" ? results[0].value : [],
    trackRecord: results[1].status === "fulfilled" ? results[1].value : null,
  };
};

/** Stage 2: Growth of $1 + OverviewStats (daily portfolio, sharpe; adjusted growth) */
export const fetchDashboardStage2 = async () => {
  const results = await Promise.allSettled([
    fetchDailyPortfolioData(),
    fetchAdjustedDailyPortfolioData(),
  ]);
  return {
    dailyPortfolioData: results[0].status === "fulfilled" ? results[0].value : null,
    adjustedGrowthData: results[1].status === "fulfilled" ? results[1].value : null,
  };
};

/** Stage 3: Assets history, Current holdings, APY chart (daily assets, monitor APR) */
export const fetchDashboardStage3 = async () => {
  const results = await Promise.allSettled([
    fetchDailyTotalAssertData(),
    fetchMonitorAprAttributes(),
  ]);
  return {
    dailyAssetsData: results[0].status === "fulfilled" ? results[0].value : null,
    monitorAprData: results[1].status === "fulfilled" ? results[1].value : [],
  };
};
